import classNames from 'classnames'
import styles from '../styles.module.scss'

export const TextAnswersList = ({ filteredFeedbacks, areAllVisible, onShowMore }) => (
    <div className={styles.feedbackRowsWrap}>
        {filteredFeedbacks?.length > 0 ? (
            <div>
                {filteredFeedbacks.map((item, index) => (
                    <div key={index} className={classNames('d-flex justify-content-between ', styles.feedbackRow)}>
                        <span>{item.ratingText}</span>
                        <span className="font-weight-bold">{item.rating}</span>
                    </div>
                ))}
                {!areAllVisible && (
                    <div className="d-flex justify-content-center">
                        <button className="btn mt-4 btn-outline-primary brand-button" onClick={onShowMore}>
                            <T>dashboard.label.show.more</T>
                        </button>
                    </div>
                )}
            </div>
        ) : (
            <span>
                <T>nps.filter.no-results</T>
            </span>
        )}
    </div>
)
